import { useState } from "react";
import Parlante from '../../../../../assets/iconos/parlante.png';
import ParlanteM from '../../../../../assets/iconos/parlantem.png';
import Play from "../../../../../assets/iconos/play.png"
import Pause from "../../../../../assets/iconos/pause.png"
import Expande from "../../../../../assets/iconos/expande.svg"
import Contrae from "../../../../../assets/iconos/contrae.svg"


const VideoFrame  = (props) => {

    const [actualQuestion, setActualQuestion] = useState(null);
    const [mute, setMute] = useState(false);
    const [paused,setPaused] = useState(true);

    const [maximize, setMaximize] = useState(false);

    const handleMute = (e) => {

        let $video = document.getElementById('actualVid');

        if($video.volume == 0){
            $video.volume = document.querySelector(".custom-range").value / 100;
            setMute(false);
        }else{
            $video.volume = 0;
            setMute(true);
        }
    }

    const handleVolume = (e) => {
        e.preventDefault()

        let $video = document.getElementById('actualVid')

        let $volume = e.target.value/100;

        $video.volume = $volume

        if ($volume === 0) {
            setMute(true);
        }
        else {
            setMute(false);
        }
    }


    const handlePause = (e) => {


        let $video = document.getElementById('actualVid');


        if ($video.paused !== true){
            $video.pause()
            setPaused(true)
        }
        else {
            $video.play()
            setPaused(false)
        }
        
    }
    

    const handleTimeUpdate = (e, data) => {
        e.preventDefault();
    
        props.Data.questions.forEach((item) => {
            if(Math.round(e.target.currentTime) == parseInt(item.time)){
                e.target.pause()
                setActualQuestion({...item, video:e.target});
            }
        })
    }

    const handleAnser = (anwser, actual) => {
        if(anwser == true){
            
            if(actual?.isConfirm){
                document.getElementById("actualVid").currentTime = Math.round(actual.video.currentTime) + 1;
                setActualQuestion(null);
                actual.video.play();
            }else{
                setActualQuestion({
                    question:actual.correct, 
                    isConfirm:true, 
                    ansers:[{ anser:'Continuar', isCorrect:true}], 
                    rollBack:actual.rollBack, 
                    video:actual.video
                });
            }

        }else{

            if(actual?.isConfirm){
                document.getElementById('actualVid').currentTime = document.getElementById('actualVid').currentTime - actual.rollBack;
                setActualQuestion(null);
                actual.video.play();
            }else{
                setActualQuestion({
                    question:actual.incorrect, 
                    isConfirm:true, 
                    ansers:[{ anser:`Volver ${actual.rollBack}s`, isCorrect:false}], 
                    rollBack:actual.rollBack, 
                    video:actual.video
                });
            }

        }
    }


    const handleEndVideo = async () => {
        if(!props.exist){
            await props.setActivityScore({score:"Finalizada", id:props.idActivity});
            props.scores.push(props.idActivity);
        }
        setPaused(true)
        props.setNext(true);
    }

    const hadnleMaximize = () => {
        setMaximize(!maximize);
    }


    return(
        <>
            <video  onTimeUpdate={e => handleTimeUpdate(e, props.Data)} onEnded={() => handleEndVideo()} className={maximize ? "canvaFrame maximized maximized-content-background" : "canvaFrame"} id="actualVid" onBlur={handlePause} controlsList="">
                <source src={props.url} type="video/mp4" className="canvaFrame"/>
            </video>
        {
            actualQuestion != null ? 
                <div className={maximize ? "questionContainer maximized" : "questionContainer"}>
                    <h1 className="questionTttle">{actualQuestion.question}</h1>
                    {
                        actualQuestion.ansers.map((item, index) => {
                            return(
                                <button className="green-btn setpointer awnser-btn" onClick={() => handleAnser(item.isCorrect, actualQuestion)} key={index}> {item.anser} </button>
                                );
                            })
                        }
                </div> 
            : 
            <></>
        }
        
        <div className={actualQuestion != null ? "options-hidden" : paused === true  ? maximize ? "questionContainer maximized" : "questionContainer" : maximize ? "video-frame-play maximized-controlsoff" : "video-frame-play"}>
            <div className={"video-buttons"}>
                        {
                            maximize ?
                            <img src={Contrae} alt="paused" className=" setpointer playbutton" onClick={hadnleMaximize}/>
                            :
                            <img src={Expande} alt="paused" className=" setpointer playbutton" onClick={hadnleMaximize}/>
                        }
                        {
                            paused !== true ? 
                            <img src={Pause} alt="paused" className=" setpointer playbutton" onClick={() => handlePause()}/>
                            :
                            <img src={Play} alt="play" className=" setpointer playbutton" onClick={() => handlePause()}/>
                            
                        }
                        <div className="volume-control">
                        <img src={mute ? ParlanteM : Parlante} className="setpointer playbutton sethovergreen" onClick={() => handleMute()}/>
                        <input type="range" onChange={(e) => handleVolume(e)} defaultValue={100} className="custom-range setpointer"/>
                </div>
            </div>
        </div>
        </>
    );
}

export default VideoFrame;